import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api';
import Swal from 'sweetalert2';

const AddReport = () => {
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [images, setImages] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);

    const staff_id = 1; // Replace with actual staff_id if available

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !description || images.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Missing Fields',
                text: 'Please fill in all fields and upload at least one image.',
            });
            return;
        }

        const formData = new FormData();
        formData.append('name', name);
        formData.append('description', description);
        formData.append('staff_id', staff_id);
        images.forEach((image) => {
            formData.append('images', image);
        });

        try {
            const response = await fetch(`${BASE_URL}reports`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.status === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Report created successfully!',
                    confirmButtonText: 'OK',
                }).then(() => {
                    navigate('/ReportsList');
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: data.message || 'Failed to create report.',
                });
            }
        } catch (err) {
            console.error('Submission error:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong. Please try again.',
            });
        }
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        setImages(files);
        const previews = files.map((file) => URL.createObjectURL(file));
        setImagePreviews(previews);
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add New Report</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">Report Details</div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Report Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Enter report name"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Enter report description"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="images" className="form-label">Report Images</label>
                                        <input
                                            type="file"
                                            id="images"
                                            className="form-control"
                                            multiple
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            required
                                        />
                                        {imagePreviews.length > 0 && (
                                            <div className="mt-3 d-flex flex-wrap gap-2">
                                                {imagePreviews.map((src, index) => (
                                                    <img
                                                        key={index}
                                                        src={src}
                                                        alt={`Preview ${index + 1}`}
                                                        width="100"
                                                        height="100"
                                                        className="border rounded"
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Create Report</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddReport;
